import { render } from "./DashboardBuilding.vue?vue&type=template&id=a128ad30&ts=true"
import script from "./DashboardBuilding.vue?vue&type=script&lang=ts"
export * from "./DashboardBuilding.vue?vue&type=script&lang=ts"

import "./DashboardBuilding.vue?vue&type=style&index=0&id=a128ad30&lang=scss"

import exportComponent from "/Users/matustrebaticky/projects/symbiosy/insights/insights-fe/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/DashboardBuilding.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a128ad30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a128ad30', __exports__)) {
    api.reload('a128ad30', __exports__)
  }
  
  module.hot.accept("./DashboardBuilding.vue?vue&type=template&id=a128ad30&ts=true", () => {
    api.rerender('a128ad30', render)
  })

}


export default __exports__